module.exports = __webpack_public_path__ + "img/btc.2a4ac9a4.svg";